<div class="w-100 h-100">
    <div class="row" style="padding-top: 59px;">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-header justify-content-between align-items-center">
                    <label class="card_header_text">
                        {{$t('shared.senderRequestPaymentTransactions')}}
                    </label>
                    <router-link :to="'/SenderRequestSupport'" tag="a" class="mx-1">
                        <button class="btn btn-primary btn-action">
                            {{$t('shared.back')}}
                        </button>
                    </router-link>

                </div>
                <div class="card-body">
                    <template>
                        <v-data-table :headers="headers"
                                      :items="senderRequestPaymentTransactionsModel"
                                      :total-items="senderRequestPaymentTransactionsCount"
                                      :rows-per-page-text="$t('shared.rowsPerPage')"
                                      :rows-per-page-items='[10, 25, 50, 100]'
                                      @update:pagination="updatePaginate"
                                      class="elevation-1 table-striped">
                            <template v-slot:items="props">
                                <tr>
                                    <td class="text-center">{{ props.item.amount }}</td>
                                    <td class="text-center">{{ props.item.paymentStatus }}</td>
                                    <td class="text-center">{{ props.item.transactionReference }}</td>
                                    <td class="text-center">{{ props.item.checkOurId }}</td>
                                    <td class="text-center">{{ props.item.isCreditLimitPayment }}</td>
                                    <td class="text-center">{{ props.item.isMada }}</td>
                                    <td class="text-center">{{ props.item.userId }}</td>
                                    <td class="text-center">{{ props.item.createdDate }}</td>
                                    <td class="text-center">{{ props.item.lastModifiedDate }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </div>
            </div>
        </div>
    </div>
</div>

